import PaymentDetails from 'components/PaymentDetails/PaymentDetails/PaymentDetails.component';
import {
	getPaymentAssessmentFee,
	getPaymentDetails,
} from 'feature/payments/paymentSlice';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import { AppDispatch } from 'store/store';
import { PaymentDetailsType } from 'types/Payment';
import { PATHNAMES } from 'utils/constants';

const ViewPaymentDetails = () => {
	const dispatch = useDispatch<AppDispatch>();
	const location = useLocation();
	const pathnames = location.pathname.split('/');
	const param = useParams<{ id: string }>();
	let isAssessmentFee = true;

	if (
		pathnames[pathnames.length - 1] === PATHNAMES.EXPLANATION_OF_PAYMENT ||
		pathnames[pathnames.length - 1] === PATHNAMES.GROUP_INVOICE_ASSESSMENT
	) {
		isAssessmentFee = false;
	}

	const paymentId = isAssessmentFee
		? pathnames[pathnames.length - 3]
		: pathnames[pathnames.length - 2];

	const detailType = isAssessmentFee
		? pathnames[pathnames.length - 2]
		: pathnames[pathnames.length - 1];

	const claimUUID = pathnames[pathnames.length - 1];

	let detailTypeRedux: PaymentDetailsType;

	switch (detailType) {
		case PATHNAMES.ASSESSMENT_FEE_INVOICE:
			detailTypeRedux = PaymentDetailsType.ASSESSMENT_FEE;
			break;
		case PATHNAMES.EXPLANATION_OF_PAYMENT:
			detailTypeRedux = PaymentDetailsType.EOP;
			break;
		case PATHNAMES.GROUP_INVOICE_ASSESSMENT:
			detailTypeRedux = PaymentDetailsType.GROUP_INVOICE;
			break;
		default:
			detailTypeRedux = PaymentDetailsType.EOP;
			break;
	}

	useEffect(() => {
		if (!paymentId || !detailType) {
			return;
		}

		if (isAssessmentFee) {
			dispatch(
				getPaymentAssessmentFee({
					showloader: true,
					claimUUID,
				}),
			);
			return;
		}

		dispatch(
			getPaymentDetails({
				showloader: true,
				paymentRunId: param.id as string,
				detailType: detailTypeRedux,
			}),
		);
	}, [
		dispatch,
		paymentId,
		detailType,
		claimUUID,
		isAssessmentFee,
		detailTypeRedux,
		param.id,
	]);

	return <PaymentDetails />;
};

export default ViewPaymentDetails;
